export const SET_APP_DATA = 'app/SET_APP_DATA';
export const SET_APP_USER = 'app/SET_APP_USER';
export const LOG_OUT_USER = 'app/LOG_OUT_USER';
export const UPDATE_USER_COUNTS = 'app/UPDATE_USER_COUNTS';
export const APP_HEARTBEAT = 'app/APP_HEARTBEAT';




// WEBPACK FOOTER //
// ./src/containers/App/App.actions.js